/**
 * Renders a dropdown menu for mobile navigation
 */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiChevronDown } from "react-icons/hi";
import { useQuery } from "@tanstack/react-query";
import MobileDropdownMenu from "./MobileDropdownMenu";

const MobileClubsDropdownMenu = ({
  title,
  closeMenu,
  layered,
  overridebg,
}) => {
  let [southClubs, northClubs] = [[], []];

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    if (closeMenu) {
      closeMenu();
    }
  };

  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["clubs"],
    queryFn: () =>
        fetch(`${process.env.REACT_APP_BUIHA_API_URL}/club/all/`).then((res) =>
            res.json()
        ),
  });

  if (isLoading || error)
    return (
        <div className={overridebg ? "bg-light-4 dark:bg-dark-4" : "bg-light-2 dark:bg-dark-1"}>
          <p className={`mr-1 font-smm leading-tight`}>{title}</p>
        </div>
    );

  return (
      // if overrridebg, dark-3 otherwiose dark4
    <div className={overridebg ? "bg-light-4 dark:bg-dark-4" : "bg-light-2 dark:bg-dark-1"}>
      <button
        onClick={toggleDropdown}
        className={`w-full flex justify-start items-center pl-2 xs:pl-[12px] py-[6px] text-sm text-left ${!overridebg ? "font-medium" : "font-normal"}`}
      >
        <p className={`mr-1 font-smm leading-tight`}>{title}</p>
        <HiChevronDown /> {/*isOpen ? <HiChevronUp /> : <HiChevronDown />*/}
      </button>
      {isOpen && (
        <div className="flex flex-col bg-light-1 dark:bg-dark-4 py-0.5">
          {/* if layered, do not display */}
          {layered ? (
            <></>
          ) : (
            <Link
              key={1}
              to={"/clubs"}
              className="py-[7px] pl-2 xs:pl-[10px] text-sm bg-light-4 dark:bg-dark-4"
              target={"_self"}
              onClick={handleLinkClick}
            >
              <div className="flex flex-row items-center justify-start">
              <img src="/buihamini.png" alt="BUIHA Logo" className="w-5 h-5 mr-1" />
                <p className="text-smm mr-1 leading-tight ">BUIHA Clubs</p>
              </div>
            </Link>
          )}
          {layered ? (
            <></>
          ) : (
            <>
              <MobileClubsDropdownMenu
                title="North"
                closeMenu={closeMenu}
                layered={true}
                overridebg={true}
              />
              <MobileClubsDropdownMenu
                title="South"
                closeMenu={closeMenu}
                layered={true}
                overridebg={true}
              />

            </>
          )}
          <div className="flex flex-wrap">
            {data.map((link) => (
              <>
                {/* If club.status == active, then show the club */}
                {link.status === "Active" && layered === true && link.location === title ? (
                  <Link
                    key={2}
                    to={"/club/" + link.stub}
                    className="pb-1 pl-1 pl-2 xs:pl-[10px] text-smm w-full xs:w-1/2"
                    target={"_self"}
                    onClick={handleLinkClick}
                  >
                    <div className="flex flex-row items-center justify-start">
                      <img
                        src={link.logo.md}
                        alt={link.name}
                        className="w-6 h-6 mr-2"
                      />
                      <p className=" xs:text-smm mr-1 leading-tight text-smm">
                        {link.name}
                      </p>
                    </div>
                  </Link>
                ) : (
                  <></>
                )}
              </>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileClubsDropdownMenu;
